import { compact } from './soundstatsHelpers';

// Circular score gauge rendered as inline SVG (no Chart.js).

export default function Gauge({ value, label, color, max }) {
  const m = max || 100000;
  const v = value == null || isNaN(value) ? 0 : Number(value);
  const pct = Math.max(0, Math.min(1, v / m));
  const r = 46;
  const c = 2 * Math.PI * r;
  return (
    <div className="ss-gauge" style={{ '--gc': color }}>
      <svg viewBox="0 0 116 116" width="112" height="112">
        <circle cx="58" cy="58" r={r} fill="none" stroke="rgba(255,255,255,.08)" strokeWidth="9" />
        <circle
          cx="58" cy="58" r={r} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round"
          strokeDasharray={`${(pct * c).toFixed(2)} ${c.toFixed(2)}`}
          transform="rotate(-90 58 58)"
        />
        <text x="58" y="56" textAnchor="middle" dominantBaseline="central" fill="#fff" fontFamily="'DM Sans',sans-serif" fontWeight="800" fontSize="18">{compact(v)}</text>
        <text x="58" y="84" textAnchor="middle" fill="rgba(255,255,255,.5)" fontFamily="'DM Sans',sans-serif" fontSize="8.5" letterSpacing="1">{String(label || '').toUpperCase()}</text>
      </svg>
    </div>
  );
}
